import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import OwnershipTransferCustomerBlockData from '../../../Models/Content/OwnershipTransferCustomerBlockData';
import OwnershipTransferCustomer from './OwnershipTransferCustomer';

export default class OwnershipTransferCustomerBlock extends EpiComponent<OwnershipTransferCustomerBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <OwnershipTransferCustomer iContent={this.props.data} />;
  }
}
